import React from 'react';

function SummaryCard({ title, children, className = "" }) {
    return (
        <section className={`mb-8 ${className}`}>
            {title && (
                <h3 className="section-title text-gray-800 mb-3">
                    {title}
                </h3>
            )}
            <div className="summary-card bg-white rounded-lg shadow-sm border border-gray-100 p-6">
                {children}
            </div>
        </section>
    );
}

export default SummaryCard;
